import VState from 'signal/v-state'

const errorDialogueState = new VState([])

export default errorDialogueState